import * as types from './constants';
import {beginAjaxCall, ajaxCallError} from '../../actions/ajaxStatusActions';
import ProjectApi from '../../api/projectApi';


function loadProjectsSuccess(projects) {
    return {type: types.LOAD_PROJECTS_SUCCESS, projects};
}

function loadProjects() {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return ProjectApi.getAll().then(projects => {
            dispatch(loadProjectsSuccess(projects));
        }).catch(error => {
            throw(error);
        });
    };
}

function loadProjectSuccess(project) {
    return {type: types.LOAD_PROJECT_SUCCESS, project};
}

function loadProject(projectId) {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return ProjectApi.getProject(projectId).then(project => {
            dispatch(loadProjectSuccess(project));
        }).catch(error => {
            throw(error);
        });
    };
}

function storeProject(data) {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return ProjectApi.store(data).then(response => {
            if (!response.error) {
                dispatch(storeProjectSuccess(response));
                return response;
            } else {
                dispatch(storeProjectFailure({errors: response.messages}));
                dispatch(ajaxCallError());
            }
        }).catch((error) => {
            dispatch(storeProjectFailure({error: error.text}));
            dispatch(ajaxCallError());
        });
    };
}

function storeProjectSuccess(project) {
    return {type: types.STORE_PROJECT_SUCCESS, project};
}

function storeProjectFailure(response) {
    return {type: types.STORE_PROJECT_FAILURE, errors: response.errors};
}

function addProjectMember(projectId,memberId){
    return function (dispatch) {
        return ProjectApi.addMember(projectId,memberId).then(user => {
            dispatch(addProjectMemberSuccess(user));
        }).catch((error) => {
            dispatch(addProjectMemberFailure({error: error.text}));
        });
    };
}

function addProjectMemberSuccess(user) {
    return {type: types.ADD_PROJECT_MEMBER_SUCCESS, user};
}

function addProjectMemberFailure(response) {
    return {type: types.ADD_PROJECT_MEMBER_FAILURE, errors: response.errors};
}

function removeProjectMember(projectId,memberId){
    return function (dispatch) {
        return ProjectApi.removeMember(projectId,memberId).then(user => {
            dispatch(removeProjectMemberSuccess(user));
        }).catch((error) => {
            dispatch(removeProjectMemberFailure({error: error.text}));
        });
    };
}

function removeProjectMemberSuccess(user) {
    return {type: types.REMOVE_PROJECT_MEMBER_SUCCESS, user};
}

function removeProjectMemberFailure(user) {
    return {type: types.REMOVE_PROJECT_MEMBER_FAILURE, user};
}


function loadProjectStats(projectId) {
    return function (dispatch) {
        dispatch(beginAjaxCall());
        return ProjectApi.getProjectStats(projectId).then(stats => {
            dispatch(loadProjectStatsSuccess(stats));
        }).catch(error => {
            throw(error);
        });
    };
}

function loadProjectStatsSuccess(stats) {
    return {type: types.LOAD_PROJECT_STATS_SUCCESS, stats};
}

export {
    loadProjects,
    loadProjectsSuccess,
    loadProject,
    loadProjectSuccess,
    storeProject,
    storeProjectSuccess,
    storeProjectFailure,
    addProjectMember,
    addProjectMemberSuccess,
    addProjectMemberFailure,
    removeProjectMember,
    loadProjectStats,
    loadProjectStatsSuccess
};


/** WEBPACK FOOTER **
 ** ./src/container/ProjectContainer/actions.js
 **/